import {SHIELD_CONTRACT} from  "../../constants/contracts";

export const web3GetTotalRewardPool = async (chainId: number, web3: any) => {
    const shieldContract = SHIELD_CONTRACT[chainId];
    const balance = await web3.eth.getBalance(shieldContract.address);
    return web3.utils.toBN(balance);
}
